export default "__VITE_ASSET__CvRHSYms__"